import { render, staticRenderFns } from "./ring-chart-center.vue?vue&type=template&id=116ae7de"
import script from "./ring-chart-center.vue?vue&type=script&lang=js"
export * from "./ring-chart-center.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports